export const FormItemType = {
  Input: 'input',
  Textarea: 'textarea',
  Select: 'select',
  TreeSelect: 'tree-select',
  InputNumber: 'input-number',
  Switch: 'switch',
  Checkbox: 'checkbox',
  CheckboxGroup: 'checkbox-group',
  RadioGroup: 'radio-group',
  Radio: 'radio',
  Upload: 'upload',
  File: 'file',
  DatePicker: 'date-picker',
  DateRangePicker: 'date-range-picker',
  DynamicList: 'dynamic-list',
}
